<template>
  <el-dialog title="批量新增企业" width="600px" :before-close="onClose" :visible.sync="showImportDialog">
    <div class="dialogTips">
      <p class="dialogTipsText">
        1.<span style="color: #26a7ff; cursor: pointer" @click="down">点击下载模板</span>
      </p>
      <p class="dialogTipsText">2.将要导入的客户数据填写到模板文件中</p>
      <p class="dialogTipsText">3.模板中表头不可更改,不可删除</p>
      <p class="dialogTipsText">4.每次导入上限为1000条,导入大量数据的情况下,请分批导入</p>
    </div>
    <el-form class="dialogForm">
      <el-form-item label="上传文件">
        <el-upload
          action="#"
          accept=".xlsx"
          :limit="1"
          :file-list="fileList"
          :on-change="changeFile"
          :on-remove="changeRemove"
          :auto-upload="false"
        >
          <el-button icon="el-icon-download" size="small" type="primary"
            >上传文件</el-button
          >
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import {getData} from "@/api/index";

export default {
  props: {
    showImportDialog:Boolean
  },
  data() {
    return {
      fileList: [],
      importData: {
        file: "",
      },
      apiHost: "",
      uploadUrl: "",
      agent:'',
      agentData:[]
    };
  },
  async created(){
    await this.$fetchDicByField("AgentData");
    this.agentData = this.$getDicByField("AgentData");
    this.apiHost = localStorage.getItem("service_cname");
    this.uploadUrl = `${this.apiHost}agent/company.CompanyController/ImportFileAction`;
  },
  methods: {
    down(){
      getData("company.CompanyController/demoAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        window.location.href = res.data;
      });
    },
    changeFile(file) {
      this.importData.file = file.raw;
    },
    changeRemove() {
      this.importData.file = "";
    },
    onClose() {
      this.importData.file = "";
      this.fileList = [];
      this.$parent.closePopDialog()
    },
    async onSubmit() {
      if (this.importData.file) {
        const formData = new FormData();
        formData.append('file',this.importData.file)
        formData.append('parent_id',this.agent)
        const res = await axios.post(this.uploadUrl, formData, {
          headers: {
            token: sessionStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        });
        if (res.data.code === 200) {
          this.onClose();
          this.$message.success("导入成功");
          this.$parent.esarchang();
        } else {
          this.$message.error(res.data.message);
        }
      } else {
        return this.$message.warning("请选择要导入的文件");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.dialogTips {
  // width: ;
  padding: 10px;
  background: #f7f7f7;
}
.dialogForm {
  margin: 20px auto;
}
/deep/ .el-drawer.rtl,
/deep/ .el-drawer.ltr {
  top: 55px !important;
}
/deep/ .el-dialog__body{
  padding: 10px 20px;
}
</style>

<style lang="less" scoped>
.main {
  display: flex;
  flex-direction: column;
  background-color: #f1f1f3;
  padding: 15px 15px;
  height: 100%;
  .det-title{
    color: #666666;
  }
  .recorddetailed{
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 22px;
    div {
      color: #666666;
      font-size: 14px;
      line-height: 27px;
      span {
        margin-right: 15px;
        color: #333333;
        text-align: left;
      }
    }
    div.det1{
      width: 38%;
      .det-title{
        width: 65px;
        display: inline-block;
      }
    }
    div.det2{
      width: 28%;
      .det-title{
        width: 75px;
        display: inline-block;
      }
    }
    div.det3{
      width: 33%;
      .det-title{
        width: 65px;
        display: inline-block;
      }
    }
   }
  .detailed {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 22px;
    div {
      color: #666666;
      font-size: 14px;
      line-height: 27px;
      span {
        margin-right: 15px;
        color: #333333;
        text-align: left;
      }
    }
    div.det1{
      width: 30%;
      .det-title{
        width: 65px;
        display: inline-block;
      }
    }
    div.det2{
      width: 40%;
      .det-title{
        width: 115px;
        display: inline-block;
      }
    }
    div.det3{
      width: 30%;
      .det-title{
        width: 75px;
        display: inline-block;
      }
    }

  }
  .detailstabs{
    background-color: white;
    margin-top: 15px;
    padding: 0 20px;
  }
  .audio-control {
    height: 155px;
    background-color: #fff;
    margin-top: 15px;
    /deep/.el-tabs__nav-wrap .is_top {
      height: 50px;
      line-height: 50px;
    }
    .audio-title{
      margin: 13px 15px;
      span,el-button{
        margin-right: 20px;
      }
    }
  }
  /deep/ .is_top .el-tabs__nav-wrap::after {
    height: 1px !important;
  }
  /deep/ .audio {
    position: relative;
  }
  .audio /dep/ .audio-speed {
    bottom: 5px;
  }
}
.head {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 21px;
  .head-l {
    font-size: 18px;
    display: flex;
    align-items: center;
    color: #333333;
    span {
      margin-right: 10px;
      background-color: #409eff;
      color: white;
      font-size: 12px;
      padding: 5px 17px;
      display: block;
      line-height: 11px;
      border-radius: 2px;
    }
  }
  .head-r {
    button {
      background-color: #f2f4fb;
      color: #333333;
      border: none;
      border-radius: 4px;
      margin-right: 12px;
      padding: 7px 16px;
      font-size: 14px;
    }
    span {
      width: 14px;
      height: 14px;
      margin-right: 19px;
      cursor: pointer;
    }
  }
}
.audio-content{
  display: flex;
  .audio-left{
    flex: 1;
    margin-right: 2%;
  }
  .audio-right{
    flex: 1;
  }
}
.btndisabled{
  opacity: 0.5;
  color: #999;
}
</style>
